import { render, staticRenderFns } from "./ViewTile.vue?vue&type=template&id=bfd5c28a&scoped=true"
import script from "./ViewTile.vue?vue&type=script&lang=js"
export * from "./ViewTile.vue?vue&type=script&lang=js"
import style0 from "./ViewTile.vue?vue&type=style&index=0&id=bfd5c28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd5c28a",
  null
  
)

export default component.exports